var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.helpText)?_c('div',[_c('p',{staticClass:"font-weight-bold text-h6 pb-0 mb-0"},[_vm._v(" "+_vm._s(_vm.$i18n.t(_vm.$router.currentRoute.meta.titleKey))+" ")]),_c('p',{staticClass:"text-subtitle-1"},[_vm._v(" "+_vm._s(_vm.helpText)+" ")]),_c('v-divider',{staticClass:"pb-5"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }